/*
+------------------------------------------------------------------------------+
+ Helper module for MSG Terms and Conditions
+
+
+
+
+
+ 
+
+------------------------------------------------------------------------------+ */
import Link from "next/link";

export function MsgAdditionalDetailsDisclaimerTC() {
  return (
    <>
      By entering my name, checking the box above and clicking Submit Request, I
      hereby (i) agree to the 
      <Link
        href={"https://www.msgentertainment.com/terms-of-use/"}
        target="_blank"
      >
        Terms of Use
      </Link>
       and the 
      <Link href={"https://www.msgentertainment.com/privacy/"} target="_blank">
        Privacy Policy
      </Link>
       and (ii) agree that my reservation will not be complete unless and until
      I receive a notice from MSG confirming whether or not my reservation has
      been accepted in accordance with our agreement.
    </>
  );
}
